import { useContext } from "react"
import ItemSelector from "./ItemSelector"
import CatalogBrowserContext from "./CatalogBrowserContext"

const SidebarCatalogBrowser = () => {
  const {addCatalogItem, addTemplate, allowDragging} = useContext(CatalogBrowserContext)
      
  return <div>
    <ItemSelector 
      onAdd={addCatalogItem}
      onTemplateAdd={addTemplate}
      draggable={allowDragging}
      docked
      width="calc(100% - 2px)"
      fixedHeight="calc(100vh - 60px)"
      horizontalPadding={16}
      hideTitle
    />
  </div>
}

export default SidebarCatalogBrowser
